import { sleep } from '@/utils/index';
import request from '@/utils/request';
import { mockInventoryEventDetailsCache } from './inventory';
import { InventoryEventTypeEnum } from './types';
import { ticketNumberInTicketBlock } from '@/utils/product';

// data type
export namespace look_up_ticket_number {
  export interface Request {
    productId: string;
    ticketNumber: string;
  }

  export interface TicketInfo {
    ticketNumber: string;
    ticketType: TicketType;
    bookingId?: string;
    inventoryId?: string;
  }

  export interface Response {
    ticketInfo?: TicketInfo;
  }

  export enum TicketType {
    UNKNOWN = 'UNKNOWN',
    INVENTORY = 'INVENTORY',
    BOOKING = 'BOOKING',
  }
}

// mock
const useMock = process.env.VUE_APP_API_USE_MOCK === 'true';

const mockLookUpTicketNumberFromInventory = (
  req: look_up_ticket_number.Request
) => {
  for (const [_, detail] of mockInventoryEventDetailsCache) {
    if (
      (detail.type as InventoryEventTypeEnum) !==
      InventoryEventTypeEnum.OUTGOING
    ) {
      continue;
    }
    for (const product of detail.products) {
      if (req.productId !== product.productId) {
        continue;
      }
      for (const ticketBlock of product.ticketBlocks) {
        if (
          ticketNumberInTicketBlock(
            req.ticketNumber,
            ticketBlock.ticketNumberStart,
            ticketBlock.ticketNumberEnd
          )
        ) {
          if (detail.bookingId) {
            return {
              ticketInfo: {
                ticketNumber: req.ticketNumber,
                ticketType: look_up_ticket_number.TicketType.BOOKING,
                bookingId: detail.bookingId,
              },
            } as look_up_ticket_number.Response;
          } else {
            return {
              ticketInfo: {
                ticketNumber: req.ticketNumber,
                ticketType: look_up_ticket_number.TicketType.INVENTORY,
                inventoryId: detail.id,
              },
            } as look_up_ticket_number.Response;
          }
        }
      }
    }
  }
  return {
    ticketInfo: undefined,
  } as look_up_ticket_number.Response;
};

const mockLookUpTicketNumberFromDummy = (
  req: look_up_ticket_number.Request
) => {
  const val = Math.random();
  if (req.ticketNumber.startsWith('x')) {
    return {
      ticketInfo: undefined,
    } as look_up_ticket_number.Response;
  } else if (val < 0.5) {
    return {
      ticketInfo: {
        ticketNumber: req.ticketNumber,
        ticketType: look_up_ticket_number.TicketType.BOOKING,
        bookingId: 'dummyBookingId',
      },
    } as look_up_ticket_number.Response;
  } else {
    return {
      ticketInfo: {
        ticketNumber: req.ticketNumber,
        ticketType: look_up_ticket_number.TicketType.INVENTORY,
        inventoryId: 'dummyInventoryId',
      },
    } as look_up_ticket_number.Response;
  }
};

const mockLookUpTicketNumber = (req: look_up_ticket_number.Request) =>
  mockLookUpTicketNumberFromInventory(req);

// api
export const lookUpTicketNumber = async (
  req: look_up_ticket_number.Request
) => {
  if (useMock) {
    await sleep(500);
    return mockLookUpTicketNumber(req);
  }

  const res = await request({
    url: '/v1/look-up-ticket-number',
    method: 'post',
    data: req,
  });
  return res.data as look_up_ticket_number.Response;
};
